export class ReporteRequest {
    public idTipoBin: number;
	public idTipoBinLatam: number;  
	public idTipoBinEspecial: number;  
    public idInstitucion: number;
	public idMarca: number;
	public idEstadoBin: number;
	public fechaInicio: string;
    public fechaFin: string;
	public periodo: number;
    public fechaCorte: string;
    constructor(){
		this.idTipoBin=null;
		this.idInstitucion = null;
        this.idMarca = null;
        this.idEstadoBin = null;
		this.fechaInicio = null;
		this.fechaFin = null;
		this.periodo = null;
		this.fechaCorte = null;
	}
}